import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { WriteOffGoodsModel } from "../models/WriteOffGoodsModel";
import { useFetchWriteOfGoods } from "../hooks/fetchDocument";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { useAppSelector } from "src/redux/hooks/hooks";
import { selectSubmitCounter } from "src/redux/slices/submitCounterSlice";
import useRunError from "src/components/Shared/useRunError";
import { WriteOffGoodsOperationTypeEnum } from "../dtos/WriteOffGoodsOperationTypeEnum";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { WriteOffGoodsDetailMain } from "./WriteOffGoodsDetailMain";
import { WriteOffGoodsDetailProducts } from "./WriteOffGoodsDetailProducts";
import { WriteOffGoodsDetailAdditional } from "./WriteOffGoodsDetailAdditional";
import { WriteOffGoodsDetailFooter } from "./WriteOffGoodsDetailFooter";

interface IProps {
  id?: string;
}

export const WriteOffGoodsDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<WriteOffGoodsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const [showComponent1, setShowComponent1] = useState(false);
  const [showComponent2, setShowComponent2] = useState(false);
  const [showComponent3, setShowComponent3] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Write Off Goods");

  const watchOperationType = watch("operationType");

  const counter = useAppSelector(selectSubmitCounter);
  const runError = useRunError(isValid, errors, counter);

  useEffect(() => {
    if (errors.companyId?.type === "required" || errors.warehouseId?.type === "required" || errors.divisionId?.type === "required" || errors.documentDate?.type === "required") {
      runError();
    }
  }, [errors, runError]);

  useEffect(() => {
    switch (watchOperationType) {
      case WriteOffGoodsOperationTypeEnum.WriteOffSpendingMaterial:
        setShowComponent1(true);
        setShowComponent2(false);
        setShowComponent3(false);
        break;
      case WriteOffGoodsOperationTypeEnum.TaxableWriteOff:
        setShowComponent1(false);
        setShowComponent2(true);
        setShowComponent3(false);
        break;
      case WriteOffGoodsOperationTypeEnum.WriteOffWithPayment:
        setShowComponent1(false);
        setShowComponent2(false);
        setShowComponent3(true);
        break;
      default:
        setShowComponent1(false);
        setShowComponent2(false);
        setShowComponent3(false);
    }
  }, [watchOperationType]);
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchWriteOfGoods({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.WriteOffGoods.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Products"} />
          <NFTab title={"Additional"} />
        </NFTabs>

        <div className={"modal-container-height"}>
          <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
          </DocumentDetailViewToolbar>

          <NFTabContainer index={0} currentIndex={tabIndex}>
            <WriteOffGoodsDetailMain />
          </NFTabContainer>
          <NFTabContainer index={1} currentIndex={tabIndex}>
            <WriteOffGoodsDetailProducts />
          </NFTabContainer>
          <NFTabContainer index={2} currentIndex={tabIndex}>
            <WriteOffGoodsDetailAdditional />
          </NFTabContainer>
        </div>
        <WriteOffGoodsDetailFooter />
      </FormProvider>
    </>
  );
};
